module.exports = __webpack_public_path__ + "img/shop_header.8ec5a7a6.png";